import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import { AllInsurancesUrl, bankDetailsUrl, beneficiaryNomineeURL, beneficiaryUrl,getBeneficiaryNomineeUrl,getPanCardImageUrl,InsuranceDetailsUrl, NomineeRelationURL, nomineeUrl, updateRelationUrl } from '../url';

export const getAllInsurances  = async (company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${AllInsurancesUrl()}?company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getInsuranceDetails  = async (insuranceType, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${InsuranceDetailsUrl()}?insurance_type=${insuranceType}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getBeneficiaryDetails  = async ( insuranceType, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${beneficiaryUrl()}?insurance_type=${insuranceType}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getNomineeRelatioAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${NomineeRelationURL()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getBankDetails  = async (insuranceType, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${bankDetailsUrl()}?insurance_type=${insuranceType}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getBeneficiaryNomineeDetails  = async (insuranceType, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getBeneficiaryNomineeUrl()}?insurance_type=${insuranceType}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getPancardImageAction  = async (beneficiary_id, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getPanCardImageUrl()}/${beneficiary_id}?company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getUpdatedReationAction  = async (firm_type) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${updateRelationUrl()}?firm_type=${firm_type}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};


// Add actions [POST]
export const AddBeneficiaryAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${beneficiaryUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const AddBeneficiaryNomineeAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${beneficiaryNomineeURL()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const AddNomineeAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${nomineeUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const AddBankDetailsAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${bankDetailsUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};


// Delete actions [DELETE]
export const deleteBeneficiaryAction = async (beneficiary_id, insuranceType, company_esi_id) => {
    return new Promise(async (next) => {
      let token = await getToken();
      await axios
        .delete(
          `${beneficiaryUrl()}?beneficiary_id=${beneficiary_id}&insurance_type=${insuranceType}&company_esi_id=${company_esi_id}`,
          getTokenHeader(token),
        )
        .then(async ({ data }) => {
          return next(data);
        })
        .catch((err) => {
          return next({ error: err });
        });
    });
};
export const deleteNomineeAction = async (beneficiary_id, nominee_id, insuranceType, company_esi_id) => {
    return new Promise(async (next) => {
      let token = await getToken();
      await axios
        .delete(
          `${nomineeUrl()}?beneficiary_id=${beneficiary_id}&nominee_id=${nominee_id}&insurance_type=${insuranceType}&company_esi_id=${company_esi_id}`,
          getTokenHeader(token),
        )
        .then(async ({ data }) => {
          return next(data);
        })
        .catch((err) => {
          return next({ error: err });
        });
    });
};

// Update actions [PATCH]
export const updateBeneficiaryAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .patch(beneficiaryUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const updateNomineeAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .patch(nomineeUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const updateBankDetailsAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .patch(bankDetailsUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};


